export interface TopicDetail {
	id?: string;
	slug?: string;
	title?: string;
	subtitle?: string;
	summary?: string;
	category?: string | null;
	classification?: import('../../domain/topicClassification').TopicClassification | null;
	coverIcon: string | null;
	coverGradient?: unknown;
	isPublic?: number;
	chapterCount?: number;
	audioMinutes?: number;
	videoCount?: number;
	readers?: number;
	subscribers?: number;
	favoriteCount?: number;
	openCount?: number;
	dynamicScore?: number;
	createdAt?: string;
	engagement?: { chapters?: number; mediaMinutes?: number; opened?: number; saved?: number };
	isFavorite?: boolean;
	voteValue?: number | null;
	keywords?: Array<{ keyword: string; coefficient: number }>;
	outcomes?: string[];
	keyTakeaways?: string[];
	faqs?: unknown;
}

export interface ChapterRow {
	index: number;
	title: string;
	duration: string;
	isFreePreview?: boolean;
	access?: { allowed: boolean };
}

export interface ResumeResult {
	loaded: boolean;
	response: { recent?: Array<{ topicId: string; topicSlug: string; chapterIndex: number; status: string; progressPercent: number }> } | null;
}

export function cleanText(value: unknown): string | undefined {
	return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export function cleanTextList(value: unknown): string[] {
	return Array.isArray(value) ? value.map(cleanText).filter((item): item is string => Boolean(item)) : [];
}

export function metricNumber(value: unknown): number | undefined {
	return typeof value === 'number' && Number.isFinite(value) && value >= 0 ? value : undefined;
}

export function isSafeClassToken(value: string): boolean {
	return /^[A-Za-z][A-Za-z0-9_-]*$/.test(value);
}

export function resolveKeywords(
	override: Array<{ keyword: string; coefficient: number }> | undefined,
	detail: TopicDetail,
	_title: string,
): Array<{ keyword: string; coefficient: number }> {
	const normalize = (items: unknown): Array<{ keyword: string; coefficient: number }> =>
		Array.isArray(items)
			? items.flatMap((item) => {
					if (typeof item?.keyword !== 'string' || item.keyword.trim().length === 0 || typeof item.coefficient !== 'number') return [];
					return [{ keyword: item.keyword, coefficient: item.coefficient }];
				})
			: [];
	const explicit = normalize(override);
	if (explicit.length) return explicit;
	return normalize(detail.keywords);
}
